import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class JwtService {

  getRegisterToken(): String {
    return window.localStorage['jwtRegisterToken'];
  }

  getLoginToken(): String {
    return window.localStorage['jwtLoginToken'];
  }

  saveRegisterToken(token: String) {
    window.localStorage['jwtRegisterToken'] = token;
  }

  saveLoginToken(token: String) {
    window.localStorage['jwtLoginToken'] = token;
  }

  destroyToken() {
    window.localStorage.removeItem('jwtLoginToken');
  }

  destroyRegisterToken() {
    localStorage.clear();
    window.localStorage.removeItem('jwtRegisterToken');
  }

}
